import React from 'react';
import { Reveal } from '../Reveal';
import { InfoIcon } from 'lucide-react';
export const Disclaimer: React.FC = () => <section className="relative bg-navy-deep py-20 overflow-hidden" data-id="element-116">
    <div className="relative max-w-3xl mx-auto px-6 lg:px-8" data-id="element-117">
      <Reveal data-id="element-118">
        <div className="rounded-2xl border border-ivory/10 bg-navy-mid/40 p-7 lg:p-8 flex items-start gap-5" data-id="element-119">
          <InfoIcon className="w-5 h-5 text-gold flex-shrink-0 mt-1" strokeWidth={1.5} data-id="element-120" />
          <div data-id="element-121">
            <h3 className="font-serif text-lg text-ivory mb-3" data-id="element-122">
              Nota importante
            </h3>
            <p className="text-ivory/55 text-sm leading-relaxed font-light" data-id="element-123">
              Este libro tiene fines educativos, reflexivos y de crecimiento
              personal. No sustituye asesoramiento médico, psicológico,
              nutricional, terapéutico ni profesional. Consulta siempre con un
              profesional calificado antes de realizar cambios importantes
              relacionados con tu salud, alimentación, ejercicio, bienestar
              emocional o estilo de vida.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>;